import { render } from "./Title.vue?vue&type=template&id=ba991234&scoped=true"
import script from "./Title.vue?vue&type=script&lang=js"
export * from "./Title.vue?vue&type=script&lang=js"

import "./Title.vue?vue&type=style&index=0&id=ba991234&scoped=true&lang=scss"

import exportComponent from "/root/tools-store-ranking-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba991234"]])

export default __exports__